import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import {Observable} from 'rxjs';
import { StorageService } from '../providers/storage.service';
import { StorageNames } from '../enum/storage-names.enum';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private storageService: StorageService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const user: any = this.storageService.get(
            StorageNames.USER
        );

        let request = req;

        if (user?.accessToken) {
            request = req.clone({
                setHeaders: {
                    authorization: `Bearer ${user?.accessToken}`,
                },
            });
        }
        return next.handle(request);
    }
}
